import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import UserAgreement from "../components/agreement/UserAgreement.vue";
import AccountDeletionStatement from "../components/agreement/AccountDeletionStatement.vue";
import CookieStatement from "../components/agreement/CookieStatement.vue";
import PrivacyPolicy from "../components/agreement/PrivacyPolicy.vue";
import CrossBorderCard from "../views/CrossBorderCaed.vue";
import CashBack from "../views/CashBack.vue";
import GiftCard from "../views/GiftCard.vue";
import OpenCard from "../components/pagenew/OpenCard.vue";
import Passwordfree from "../views/passwordfree.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/opencard",
    name: "openCard",
    component: OpenCard,
  },
  {
    path: "/agreement/user-agreement",
    name: "user-agreement",
    component: UserAgreement,
  },
  {
    path: "/agreement/account-deletion-statement",
    name: "account-deletion-statement",
    component: AccountDeletionStatement,
  },
  {
    path: "/agreement/cookie-statement",
    name: "cookie-statement",
    component: CookieStatement,
  },
  {
    path: "/agreement/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/crossBorderCard",
    name: "crossBorderCard",
    component: CrossBorderCard,
  },
  {
    path: "/cashBack",
    name: "cashBack",
    component: CashBack,
  },
  {
    path: "/giftCard",
    name: "giftCard",
    component: GiftCard,
  },
  {
    path: "/passwordfree",
    name: "passwordfree",
    component: Passwordfree,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
